import angular from 'angular';

import { VerbatimController } from './verbatim.controller.js';
import { VerbatimService } from './verbatim-services.js';


angular
  .module('verbatim', [])
  .controller('VerbatimController', VerbatimController)
  .factory('VerbatimFactory', VerbatimService.VerbatimFactory)